import React from "react"
import styled from "styled-components"
import { Card, Tag } from "antd"
const { Meta } = Card

export default function MovieCard({ title, poster, overview, genres }) {
  return (
    <StyledCard cover={<CardCover alt={title} src={poster} />} hoverable>
      <CardContent>
        <Meta title={title} description={overview} />
        <Tags>
          {genres &&
            genres.map(x => (
              <StyledTag key={x} color="default">
                {x}
              </StyledTag>
            ))}
        </Tags>
      </CardContent>
    </StyledCard>
  )
}

const StyledCard = styled(Card)`
  margin: 20px 0;
  @media (min-width: 768px) {
    display: flex;
    margin: 24px 0;
    max-width: 740px;
  }
`

const CardContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const CardCover = styled.img`
  display: block;
  width: 100px;
  margin: 24px 24px 0;
  @media (min-width: 768px) {
    width: 150px;
    margin: 0;
  }
`

const Tags = styled.div`
  margin: 24px 0 0;
`

const StyledTag = styled(Tag)`
  margin: 6px 6px 0 0;
`
